export default __webpack_public_path__ + "static/media/hot-stone.03fd5587.jpg";